import React from 'react';

import { makeStyles } from 'core/components/library';
import { Divider, Grid, Typography } from 'core/components/library';

import * as icons from 'core/icons';
import * as enums from 'core/enums';
import * as hlprs from 'core/helpers';

import List from 'store/List';

import { Avatar, Combo, Select, Text, Switch, Document } from 'core/components';

import DetailBodega from 'views/maestros/Bodegas/Detalle';
import DetailViticultor from 'views/maestros/Viticultores/Detalle';
import {
    ENTITY_BODEGA,
    ENTITY_VITICULTOR
} from '../../../store/entities/constants';

const useStyles = makeStyles(theme => ({
    root: {},
    wrapper: {
        display: 'flex',
        width: '100%',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center'
    }
}));

const ComboBodegas = List(Combo, 'options', 'lstbodegas');
const ComboViticultores = List(Combo, 'options', 'lstviticultores');
const ComboRoles = List(Combo, 'options', 'lstRoles');

const Detalle = props => {
    const {
        auth,
        values,
        editing,
        adding,
        handleChange,
        handleError,
        refresh
    } = props;
    const classes = useStyles();

    return (
        <form autoComplete='on' noValidate>
            <Grid container spacing={1}>
                <Grid item xs>
                    <Avatar
                        size='medium'
                        sx={{ marginBottom: '10px', marginLeft: '10px' }}
                        //variant="square"
                        //color="secondary"
                        //hidden={!values.propietario}
                        value={values.nombre}
                        image={hlprs.getAvatar(values.id, values.avatar)}
                    />
                </Grid>
                <Grid item xs>
                    <Grid container alignItems={'center'} spacing={1}>
                        <Grid item>
                            <Switch
                                value={values.activo}
                                onChange={handleChange}
                                name='activo'
                                label='Activo'
                                editing={editing}
                            />
                        </Grid>
                        <Grid item>
                            <Avatar
                                size='large'
                                variant='square'
                                //color='secondary'
                                //hidden={!values.propietario}
                                //value={values.nombre}
                                image={'/recursos/imagenes/logos/logo.png'}
                            />
                        </Grid>
                        <Grid item>
                            <Grid container direction={'column'}>
                                <Grid item>
                                    <Typography variant='h5'>
                                        Gestión Integral Comercial Agricola
                                        Gandera, SL
                                    </Typography>
                                </Grid>
                                <Grid item>
                                    <Typography variant='caption'>
                                        {`Licencia: ${values.id}`}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Grid container spacing={1}>
                <Grid item xs>
                    <Text
                        fullWidth
                        name='nombre'
                        label='Nombre'
                        //helperText="Nombre del usuario"
                        value={values.nombre}
                        onChange={handleChange}
                        editing={editing}
                    />
                </Grid>
                <Grid item xs>
                    <Text
                        fullWidth
                        name='email'
                        label='eMail'
                        //helperText="Correo electronico"
                        value={values.email}
                        onChange={handleChange}
                        editing={editing}
                    />
                </Grid>
            </Grid>

            <Grid container spacing={1}>
                <Grid item xs={3}>
                    <Text
                        fullWidth
                        name='puesto'
                        label='Cargo'
                        //helperText="Correo electronico"
                        value={values.puesto}
                        onChange={handleChange}
                        editing={editing}
                    />
                </Grid>
                <Grid item xs>
                    <ComboRoles
                        fullWidth
                        api='roles'
                        multiple
                        name='roles'
                        label='Roles'
                        Icon={icons.RolIcon}
                        //helperText="Roles a los que pertenece el usuario"
                        value={values.roles}
                        onChange={handleChange}
                        editing={editing}
                        propertyValue='id'
                        getOptionLabel={option =>
                            !option.equipo
                                ? `* ${option.id}`
                                : `${option.equipo.id} - ${option.id}`
                        }
                        refresh={refresh}
                    />
                </Grid>
            </Grid>
            {values.roles &&
                values.roles.some(
                    item => item.id === 'Bodega' || item.id === 'Viticultor'
                ) && (
                    <>
                        <Grid container spacing={1} style={{ margin: '10px' }}>
                            <Grid item xs>
                                <Typography variant='caption'>
                                    Pertenece
                                </Typography>
                                <Divider />
                            </Grid>
                        </Grid>

                        {values.roles.some(item => item.id === 'Bodega') && (
                            <Grid container spacing={1}>
                                <Grid item xs>
                                    <ComboBodegas
                                        //required
                                        fullWidth
                                        api='bodegas'
                                        name='bodega'
                                        nameKey='bodegaid'
                                        label='Bodega'
                                        relacionado={{
                                            type: ENTITY_BODEGA,
                                            Detail: DetailBodega,
                                            resume: ['nombre'],
                                            readOnly: false
                                        }}
                                        refresh={refresh}
                                        Icon={icons.CellarIcon}
                                        value={values.bodega}
                                        onChange={handleChange}
                                        onError={handleError}
                                        editing={editing}
                                        propertyValue='id'
                                        getOptionLabel={option =>
                                            `${option.nombre}-[${option.nif}]`
                                        }
                                        searchKeys={['nombre', 'nif']}
                                        filters={[
                                            {
                                                fields: ['estado'],
                                                values: ['Activo'],
                                                operator: 'in',
                                                type: 'text'
                                            }
                                        ]}
                                    />
                                </Grid>
                            </Grid>
                        )}
                        {values.roles.some(
                            item => item.id === 'Viticultor'
                        ) && (
                            <Grid container spacing={1}>
                                <Grid item xs>
                                    <ComboViticultores
                                        //required
                                        fullWidth
                                        api='viticultores'
                                        name='viticultor'
                                        nameKey='viticultorid'
                                        label='Viticultor'
                                        relacionado={{
                                            type: ENTITY_VITICULTOR,
                                            Detail: DetailViticultor,
                                            resume: ['nombre'],
                                            readOnly: false
                                        }}
                                        refresh={refresh}
                                        Icon={icons.ViticultoresIcon}
                                        value={values.viticultor}
                                        onChange={handleChange}
                                        onError={handleError}
                                        editing={editing}
                                        propertyValue='id'
                                        getOptionLabel={option =>
                                            `${option.nombre}-[${option.codigo}]-[${option.nif}]-[${option.estado}]`
                                        }
                                        filters={[
                                            {
                                                fields: ['estado'],
                                                values: ['Activo', 'Borrador'],
                                                operator: 'in',
                                                type: 'text'
                                            }
                                        ]}
                                        searchKeys={[
                                            'codigo',
                                            'nombre',
                                            'nif',
                                            'estado'
                                        ]}
                                    />
                                </Grid>
                            </Grid>
                        )}
                    </>
                )}
            <Grid container spacing={1}>
                <Grid item xs>
                    <Grid container spacing={1} style={{ margin: '10px' }}>
                        <Grid item xs>
                            <Typography variant='caption'>
                                Datos de inicio de sesión
                            </Typography>
                            <Divider />
                        </Grid>
                    </Grid>
                    <Grid container spacing={1}>
                        <Grid item xs>
                            <Text
                                fullWidth
                                name='login'
                                label='Login'
                                //helperText="Login de usuario"
                                value={values.login}
                                onChange={handleChange}
                                editing={editing}
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={1}>
                        <Grid item xs>
                            <Text
                                fullWidth
                                //type='password'
                                name='password'
                                label='Password'
                                //helperText="Password del usuario"
                                value={values.password}
                                onChange={handleChange}
                                editing={editing}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs>
                    <Grid container spacing={1} style={{ margin: '10px' }}>
                        <Grid item xs>
                            <Typography variant='caption'>Firma</Typography>
                            <Divider />
                        </Grid>
                    </Grid>
                    <Grid
                        sx={{ marginTop: '20px', marginBottom: '20px' }}
                        container
                        justifyContent={'center'}
                        alignItems={'center'}
                    >
                        <Document
                            name='firma'
                            readOnly={!editing}
                            width='300px'
                            height='200px'
                            value={values.firma}
                            onChange={handleChange}
                        />
                    </Grid>
                </Grid>
            </Grid>
        </form>
    );
};

export default Detalle;
